import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router-dom';

export function NotFoundPage() {
  const error = useRouteError();
  const { t } = useTranslation('core.nav');

  return (
    <div className="flex h-full min-h-screen w-full items-center justify-center p-6 bg-[var(--color-bg)]">
      <div className="max-w-md text-center">
        <div className="text-[48px] font-semibold leading-none text-[var(--color-text-primary)]">
          404
        </div>
        <p className="mt-2 text-[13px] text-[var(--color-text-secondary)]">
          {String(
            (error as { statusText?: string; message?: string })?.statusText ??
              (error as { message?: string })?.message ??
              '',
          )}
        </p>
        <div className="mt-6">
          <Link
            to="/home"
            data-testid="not-found-home-link"
            data-feature="navigation"
            data-module="core"
            data-action="navigate"
            className="inline-flex items-center gap-2 rounded-[4px] border border-[var(--color-border)] bg-[var(--color-bg)] px-4 py-2 text-[13px] font-medium text-[var(--color-text-primary)] hover:bg-[var(--color-surface)]"
          >
            {t('home')}
          </Link>
        </div>
      </div>
    </div>
  );
}
